<template><div><code-well-header>
  <dt-emoji-text-wrapper>
    Some text with :invalid-emoji: :smile: :cry: and 😄, and custom emojis :octocat: :shipit:
  </dt-emoji-text-wrapper>
</code-well-header>
<h2 id="variants-and-examples" tabindex="-1" class="d-docsite--header-2">Variants and Examples <a class="header-anchor d-link d-docsite--link d-link" href="#variants-and-examples" aria-hidden="true">#</a></h2>
<h3 id="text-only" tabindex="-1" class="d-docsite--header-3">Text Only <a class="header-anchor d-link d-docsite--link d-link" href="#text-only" aria-hidden="true">#</a></h3>
<code-well-header>
  <dt-emoji-text-wrapper>
    Some text with :invalid-emoji: :smile: :cry: and 😄, and custom emojis :octocat: :shipit:
  </dt-emoji-text-wrapper>
</code-well-header>
<code-example-tabs
htmlCode='
<div class="d-emoji-text-wrapper">
  <span> Some text with :invalid-emoji: </span>
  <span class="d-emoji d-icon d-icon--size-500">
    <div aria-busy="true" role="status" aria-label="" class="d-icon d-icon--size-500" style="display: none;">
      <div class="d-skeleton-placeholder d-bar-circle d-skeleton-placeholder--animate" style="animation-delay: 0ms; animation-duration: 1000ms; min-width: 100%; max-width: 100%; min-height: 100%; max-height: 100%;"></div>
    </div>
    <img class="d-icon d-icon--size-500" aria-label="grinning face with smiling eyes" alt="😄" title="grinning face with smiling eyes" src="https://cdn.jsdelivr.net/joypixels/assets/8.0/png/unicode/32/1f604.png" style="" />
  </span>
  <span> </span>
  <span class="d-emoji d-icon d-icon--size-500">
    <div aria-busy="true" role="status" aria-label="" class="d-icon d-icon--size-500" style="display: none;">
      <div class="d-skeleton-placeholder d-bar-circle d-skeleton-placeholder--animate" style="animation-delay: 0ms; animation-duration: 1000ms; min-width: 100%; max-width: 100%; min-height: 100%; max-height: 100%;"></div>
    </div>
    <img class="d-icon d-icon--size-500" aria-label="crying face" alt="😢" title="crying face" src="https://cdn.jsdelivr.net/joypixels/assets/8.0/png/unicode/32/1f622.png" style="" />
  </span>
  <span> and </span>
  <span class="d-emoji d-icon d-icon--size-500">
    <div aria-busy="true" role="status" aria-label="" class="d-icon d-icon--size-500" style="display: none;">
      <div class="d-skeleton-placeholder d-bar-circle d-skeleton-placeholder--animate" style="animation-delay: 0ms; animation-duration: 1000ms; min-width: 100%; max-width: 100%; min-height: 100%; max-height: 100%;"></div>
    </div>
    <img class="d-icon d-icon--size-500" aria-label="grinning face with smiling eyes" alt="😄" title="grinning face with smiling eyes" src="https://cdn.jsdelivr.net/joypixels/assets/8.0/png/unicode/32/1f604.png" style="" />
  </span>
  <span>, and custom emojis :octocat: :shipit: </span>
</div>
'
vueCode='
<dt-emoji-text-wrapper>
  Some text with :invalid-emoji: :smile: :cry: and 😄, and custom emojis :octocat: :shipit:
</dt-emoji-text-wrapper>
'
showHtmlWarning />
<h3 id="variants" tabindex="-1" class="d-docsite--header-3">Variants <a class="header-anchor d-link d-docsite--link d-link" href="#variants" aria-hidden="true">#</a></h3>
<code-well-header>
  <div class="d-stack16" ref="variantsExample">
    <dt-emoji-text-wrapper>
      <button class="d-btn d-btn--primary d-btn--danger">
        Button with shortcode :cry: emoji
      </button>
    </dt-emoji-text-wrapper>
    <dt-emoji-text-wrapper>
      Text only with unicode 😃 emoji
    </dt-emoji-text-wrapper>
    <dt-emoji-text-wrapper>
      <button class="d-btn d-btn--primary">
        Button wrapper :smile:
      </button>
    </dt-emoji-text-wrapper>
    <dt-emoji-text-wrapper size="800">
      Bigger emoji size :smile:
    </dt-emoji-text-wrapper>
    <dt-emoji-text-wrapper size="300">
      Smaller emoji size :smile:
    </dt-emoji-text-wrapper>
  </div>
</code-well-header>
<code-example-tabs
:htmlCode="() => $refs.variantsExample"
vueCode='
<dt-emoji-text-wrapper>
  <button class="d-btn d-btn--primary d-btn--danger">
    Button with shortcode :cry: emoji
  </button>
</dt-emoji-text-wrapper>
<dt-emoji-text-wrapper>
  Text only with unicode 😃 emoji
</dt-emoji-text-wrapper>
<dt-emoji-text-wrapper>
  <button class="d-btn d-btn--primary">
    Button wrapper :smile:
  </button>
</dt-emoji-text-wrapper>
<dt-emoji-text-wrapper size="800">
  Bigger emoji size :smile:
</dt-emoji-text-wrapper>
<dt-emoji-text-wrapper size="300">
  Smaller emoji size :smile:
</dt-emoji-text-wrapper>
'
/>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="emojitextwrapper" /><h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<h3 id="import" tabindex="-1" class="d-docsite--header-3">Import <a class="header-anchor d-link d-docsite--link d-link" href="#import" aria-hidden="true">#</a></h3>
<div class="language-javascript" data-highlighter="prismjs" data-ext="js"><pre v-pre><code class="language-javascript"><span class="line"><span class="token keyword">import</span> <span class="token punctuation">{</span> DtEmojiTextWrapper <span class="token punctuation">}</span> <span class="token keyword">from</span> <span class="token string">'@dialpad/dialtone-vue'</span><span class="token punctuation">;</span></span>
<span class="line"></span></code></pre>
</div><h3 id="limitations" tabindex="-1" class="d-docsite--header-3">Limitations <a class="header-anchor d-link d-docsite--link d-link" href="#limitations" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">Currently, this wrapper component <strong>can't handle Vue components</strong>, make sure to wrap only native HTML elements and text.</p>
<h3 id="custom-emojis" tabindex="-1" class="d-docsite--header-3">Custom Emojis <a class="header-anchor d-link d-docsite--link d-link" href="#custom-emojis" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">It supports custom emojis, you can use the shortcode to display them. For example, <code v-pre>:octocat:</code> will render the octocat emoji.
To do this, you need to <RouteLink to="/components/emoji.html#custom-emoji" class="d-docsite--link d-link">set up custom emojis</RouteLink> in your application.</p>
</div></template>


